import React from 'react'
import './index.css'
import logUtil from 'utils/log'
import getSelectedUseItWithVariantProductSelect from 'modules/product/redux/selectors/get-selected-perfect-your-look-variant'
import useSelector from 'hooks/use-selector'
import ButtonOutlined from 'components/ButtonOutlined'
import getByVariantIdAddLabelSelector from 'modules/product/redux/selectors/get-by-variant-id-add-label'
import isDisabledByIdVariantSelector from 'modules/variant/redux/selectors/is-disabled-by-id'
import getPriceProductVariantUtil from 'modules/product-variant/utils/get-price'
import toggleAddRemoveProductCartAction from 'modules/cart/redux/actions/toggle-add-remove'
import useDispatch from 'hooks/use-dispatch'
import CheckmarkIcon from 'components/Icons/Checkmark'
import hasVariantByIdInCartSelector from 'modules/cart/redux/selectors/has-variant-by-id-in-cart'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import getDiscountPercentageFromVariantInfoSelector from 'modules/variant/redux/selectors/get-discount-percentage-from-variant-info'
import getDiscountDataSelectorProductCollectionItemSelector from 'containers/ProductCollection/components/Item/redux/selectors/get-discount-data'

const ANALYTIC_EVENT_PREFIX = 'PERFECT_YOUR_LOOK'

/**
 * @params {object} props
 * @params {string} props.analyticEventPrefix
 * @returns {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarUseItWithButton (props) {
  /**
   * @type {ProductVariantCollection}
   */
  const selectedUseItWithVariant = useSelector(getSelectedUseItWithVariantProductSelect)
  const dispatch = useDispatch()

  const disabled = useSelector(
    isDisabledByIdVariantSelector({
      productVariant: selectedUseItWithVariant
    })
  )

  const priceStr = getPriceProductVariantUtil(selectedUseItWithVariant)
  const price = priceStr
    ? parseFloat(priceStr)
    : null

  const variantId = selectedUseItWithVariant?.variant_id

  const discountPercentage = useSelector(
    getDiscountPercentageFromVariantInfoSelector({ variantId })
  )
  const {
    discountPrice
  } = useSelector(
    getDiscountDataSelectorProductCollectionItemSelector({
      discountPercentage,
      isFullSize: true,
      price,
      productVariant: selectedUseItWithVariant
    })
  )

  const label = useSelector(
    getByVariantIdAddLabelSelector({
      discountPrice,
      variantId,
      productVariant: selectedUseItWithVariant,
      isFromGrid: true,
      disabled,
      price
    })
  )

  const isInCart = useSelector(
    hasVariantByIdInCartSelector(variantId)
  )

  const handleClick = async () => {
    logUtil('QuickShopProductSidebarUseItWithButton#handleClick').debug('[start]')

    let analyticEventPrefix
    if (props.analyticEventPrefix) {
      analyticEventPrefix = getActionStrReduxUtil(props.analyticEventPrefix, ANALYTIC_EVENT_PREFIX)
    } else {
      analyticEventPrefix = ANALYTIC_EVENT_PREFIX
    }

    await dispatch(
      toggleAddRemoveProductCartAction({
        variantId: selectedUseItWithVariant?.variant_id,
        productVariant: selectedUseItWithVariant,
        analyticEventPrefix
      })
    )
  }

  const debugProps = {
    selectedUseItWithVariant
  }
  logUtil('QuickShopProductSidebarUseItWithButton').debug('debugProps=', debugProps)
  let icon
  if (isInCart) {
    icon = <CheckmarkIcon />
  }

  return (
    <ButtonOutlined
      className='quick-shop-product-sidebar-perfect-your-look-product-button'
      onClick={handleClick}
      disabled={disabled}
    >
      {icon}
      {label}
    </ButtonOutlined>
  )
}
